<template>
  <div class="status-progress">
    <el-steps :active="activeItem" :align-center="iscenter">
      <el-step 
        v-for="(item, index) in items" 
        :key="index" 
        :title="index >= activeItem ? item.operation + item.tip : item.completeText" 
        @click="onClickStatus(item)" 
        :class="[index+1 == activeItem ? 'change-line' :'',
        item.color=='red' ?'abnormal': (item.color=='orange'?'pending':''),item.name==='BILL_DELETE' ? 'closed' :'']">
        <el-button type="text" slot="icon" size="mini" @click="onClickStatus(item)" :class="['iconfont',item.icon]"></el-button>
        
        <div slot="description">
          <div class="operatorName">{{item.operatorName}}</div>
          
          <div v-if="item.history && item.history.length > 0">
            <div v-for="(history, index) in item.history" :key="index" :class="{'expired':history.expired}">
              <div><span style="white-space: nowrap;">{{history.time}}</span></div>
            </div>
          </div>
        </div>
      </el-step>
    </el-steps>
  </div>
</template>
<script>
/**
   * 订单状态进度条，用于展示订单的整体进度状态 test
   */
import {
  formatDateObject
} from '@/utils/formUtils'
import TRUSTDEED from '@/config/order/flows/TRUSTDEED'

export default {
  name: 'status-progress',
  props: {
    statusList:{
      type:Array,
      default:()=>TRUSTDEED
    },
    // 当前状态
    status:{
      type:String,
      required: true,
    },
    // 待办任务
    task: {
      type: Object
    },
    // 用户操作状态记录
    operationList:{
      type:Array,
      default:()=>[]
    },
    isClosed:{
      type:Boolean,
      default: false,
    },
    isComplete:{
      type:Boolean,
      default: false,
    },
  },
  data () {
    return {
      items: this.buildStatusList(this.statusList),
      iscenter: true,
      creatNum: 0,
      isShowClose: false
    }
  },
  computed: {
    activeItem(){
      if(this.isClosed){
        const lastAction = this.operationList[this.operationList.length-1-1].status
        return this.items.findIndex(e=>e.name===lastAction) + 1
      }
      if(this.isComplete){
        return this.items.length + 1
      }
      return this.items.findIndex(e=>e.name===this.status)
    }
  },
  watch: {
    task:{
      handler: function (val) {
        this.items = this.buildStatusList(this.statusList)
      },
      // immediate: true,
    },
    isClosed(val){
       this.items = this.buildStatusList(this.statusList)
    },
    operationList:{
      handler: function (val) {
        this.items = this.buildStatusList(this.statusList)
      },
      immediate: true,
    },
  },
  methods: {
    buildStatusList(statusList){
      let list  = this.isClosed ? statusList.filter(e=>e.name !=='BILL_COMPLETED') : statusList.filter(e=>e.name !=='BILL_DELETE')

      // 当前待办状态
      const taskAction = this.task && this.task.billActionData.action 
      const taskActionIndex = list.findIndex(e=>e.name === taskAction)

      // 填充操作记录
      list.forEach((item,index)=>{
        // 待办时状态后面的提示，如：待审核（驳回）
        if(this.activeItem === index && taskActionIndex >=0){
          item.tip = `（${this.task.reason}）`
          // 修改颜色
          item.color = 'orange' 
        }else{
          item.tip = ''
          item.color = ''
        }
        const opr = this.operationList.find(e=>e.status === item.name)
        if(opr){
          item.history = [{
            time: formatDateObject(opr.statusTime, 'shortDatetime')
          }]
          // 操作人
          item.operatorName = opr?.auditInformation?.operatorName
        }else{
          item.history = null
          item.operatorName = null
        }
      })
      return  list
    },
    onClickStatus (item) {
      this.$emit('statusClick', item)
    }
  },
  created () { }
}

</script>
<style lang="less">
@import "~less/var.less";

.status-progress {
  // 更新element版本后，做的样式修改
  .el-steps {
    display: flex;
    justify-content: center;
  }

  .el-step__head.is-process {
    .el-step__icon {
      background-color: @iconBackgroundColor;
    }
  }

  .el-step__head.is-wait {
    // background-color: #d5d5d5;
    // border-color: #d5d5d5;
    .el-step__icon {
      background-color: #d5d5d5;
    }
  }

  .el-step__icon.is-text {
    border: none;
  }

  .el-step__head.is-horizontal {
    background-color: @mainColor;
    border-color: @mainColor;

    .el-step__icon {
      background-color: @mainColor;
    }
  }

  .el-step__icon,
  .closed .el-step__head.is-wait .el-step__icon {
    background-color: @iconCompletedColor;
    width: 40px;
    height: 40px;
  }
  .el-step__title {
    line-height: 1.2 !important;
    margin: 10px 0;
  }
  .closed .el-step__title {
    color: @iconCompletedColor;
  }

  .el-step__head {
    position: static;
  }

  .el-step.is-horizontal .el-step__line {
    top: 22px;
    height: 2px;
    // left: 40px;
    // right: 0;
  }

  .expired {
    line-height: 20px;
    // color: #BBBBBB
  }

  button {
    background: none;
    border: none;
    color: white;
    min-width: 20px;

    span {
      color: white !important;
    }

    &:hover {
      color: white;
    }

    &:active {
      color: white;
    }
  }

  .hidden {
    display: none;
  }

  .only-data {
    display: none;
  }

  .el-step__head.is-finish {
    border-color: @iconCompletedColor;
  }

  .el-step__title.is-finish,
  .el-step__description.is-finish {
    color: @iconCompletedColor;
  }

  .change-line {
    > .el-step__head.is-finish {
      > .el-step__line .el-step__line-inner {
        transition-delay: 300ms !important;
        border-width: 1px !important;
        width: 50% !important;
      }
    }
  }

  .el-step__description {
    line-height: 0.1rem;
  }

  .el-button--mini {
    font-size: 22px;
  }

  .pending {
    .el-step__head .el-step__icon {
      background-color: #f69b07;
      border-color: #f69b07;
    }

    .el-step__title {
      color: #f69b07;
    }

    .el-step__description.is-process {
      color: #f69b07;
    }
  }

  .abnormal {
    .el-step__head.is-process .el-step__icon,
    .el-step__head .el-step__icon {
      background-color: #f56c6c;
      border-color: #f56c6c;
    }

    .el-step__title.is-process,
    .el-step__title {
      color: #f56c6c;
    }

    .el-step__description.is-process {
      color: #f56c6c;
    }
  }

  p {
    line-height: 15px;
  }

  span {
    line-height: 15px;
  }
  .operatorName {
    margin: 5px 0;
  }
}
</style>
